import { useEffect, useState } from "react";
import { MapPin, Phone, Smartphone, Mail, Globe, ShieldCheck } from "lucide-react";
import clienteApi from "../../lib/clienteApi";

const Item = ({ icon: I, href, children, testId }) => {
  const cls = "flex items-start gap-1.5 min-w-0 text-slate-600";
  const inner = <><I className="h-3 w-3 mt-0.5 shrink-0 text-amber-600" /><span className="min-w-0 break-words [overflow-wrap:anywhere]">{children}</span></>;
  return href
    ? <a href={href} className={`${cls} hover:text-amber-700 transition-colors`} data-testid={testId}>{inner}</a>
    : <span className={cls} data-testid={testId}>{inner}</span>;
};

export const ClienteStudioHeader = ({ data = null }) => {
  const [s, setS] = useState(data);
  useEffect(() => {
    if (data) { setS(data); return; }
    clienteApi.get("/cliente/studio").then(({ data: d }) => {
      setS(d);
      if (d.tenant_id && localStorage.getItem("pgp_cli_tenant") !== d.tenant_id) {
        localStorage.setItem("pgp_cli_tenant", d.tenant_id);
        window.dispatchEvent(new Event("pgp-cli-tenant"));
      }
    }).catch(() => {});
  }, [data]);
  if (!s) return null;
  const addr = [s.indirizzo, [s.cap, s.citta].filter(Boolean).join(" "), s.provincia ? `(${s.provincia})` : ""].filter(Boolean).join(", ");
  const web = s.sito_web && (s.sito_web.startsWith("http") ? s.sito_web : `https://${s.sito_web}`);
  return (
    <section className="pgp-card p-4 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6" data-testid="cliente-studio-header">
      {s.logo && (
        <div className="h-16 sm:h-20 w-full sm:w-44 shrink-0 rounded-lg bg-white flex items-center justify-center overflow-hidden" data-testid="cliente-studio-logo">
          <img src={s.logo} alt={s.studio_name} className="max-h-full max-w-full object-contain" />
        </div>
      )}
      <div className="min-w-0 flex-1 space-y-2">
        <h1 className="font-head text-base sm:text-lg font-bold leading-snug text-slate-900 break-words" data-testid="cliente-studio-name">{s.studio_name}</h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1 text-xs">
          {addr && <Item icon={MapPin} testId="cliente-studio-indirizzo">{addr}</Item>}
          {s.telefono && <Item icon={Phone} href={`tel:${s.telefono.replace(/\s/g, "")}`} testId="cliente-studio-telefono">{s.telefono}</Item>}
          {s.cellulare && <Item icon={Smartphone} href={`tel:${s.cellulare.replace(/\s/g, "")}`} testId="cliente-studio-cellulare">{s.cellulare}</Item>}
          {s.email && <Item icon={Mail} href={`mailto:${s.email}`} testId="cliente-studio-email">{s.email}</Item>}
          {s.pec && <Item icon={ShieldCheck} href={`mailto:${s.pec}`} testId="cliente-studio-pec">PEC: {s.pec}</Item>}
          {web && <Item icon={Globe} href={web} testId="cliente-studio-web">{s.sito_web}</Item>}
        </div>
      </div>
    </section>
  );
};
